import {centerCrop, makeAspectCrop} from 'react-image-crop';

export enum MediaType {
    JPG = 'jpg',
    JPEG = 'jpeg',
    WEBP = 'webp',
    PNG = 'png',
    GIF = 'gif',
    SVG = 'svg',
    SVG_XML = 'svg+xml',
    MP4 = 'mp4',
    AVI = 'avi',
}

export async function getImageWidthAndHeight(imageUrl: string): Promise<[number, number]> {
    return new Promise<[number, number]>((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            resolve([img.width, img.height]);
        };
        img.onerror = () => {
            reject(new Error("Couldn't load image'"));
        };
        img.src = imageUrl;
    });
}

export function centerAspectCrop(mediaWidth: number, mediaHeight: number, aspect: number) {
    return centerCrop(
        makeAspectCrop(
            {
                unit: '%',
                x: 0,
                y: 0,
                width: 100,
                height: 100,
            },
            aspect,
            mediaWidth,
            mediaHeight,
        ),
        mediaWidth,
        mediaHeight,
    );
}
export const getImageSize = async (url: string) => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        return blob.size;
    } catch (e) {
        console.error('Something went wrong while fetching image details.', e);
        return 0;
    }
};

export const urlOperation = async (url: string) => {
    const name = url.substring(url.lastIndexOf('/') + 1);
    const [file_size, [width, height]] = await Promise.all([getImageSize(url), getImageWidthAndHeight(url)]);
    return {name, file_size, cdn_url: url, width, height, tags: [], captions: null};
};

// if original file name is image.jpeg, but it's now a png image, return image.png
export function getCorrectedName(name: string, actualType?: string): string {
    if (!actualType) {
        return name;
    }
    const extensions = Object.values(MediaType).map(String);
    const extension = name.split('.').pop();
    if (extension !== actualType && !!extension && extensions.includes(extension)) {
        return name.replace(`.${extension}`, `.${actualType}`);
    } else {
        return name;
    }
}
